export default __webpack_public_path__ + "media/components/Header/Images/Logo-8a17bca006c60f7fb78fa873959b2303.svg";